module.exports = __webpack_public_path__ + "img/tools5.5172a2ca.png";